export const ua = window.navigator.userAgent;
export const isDeviceAndroid = !!ua.match(/android/i);
export const isDeviceIOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
export const webkit = !!ua.match(/WebKit/i);
export const isStandalone =
  // @ts-ignore
  ("standalone" in navigator && window.navigator.standalone) ||
  window.matchMedia("(display-mode: standalone)").matches;
export const isDeviceIOSAndBrowserSafari = isDeviceIOS && webkit && !ua.match(/CriOS/i);
